import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useEffect, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Col, Row } from "reactstrap";
import Records from "./table";
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useVervangerData } from "Api/Coordinator/Verzoeken/VervangerZoeken";

const Default = () => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearchValue] = useState("");
    const [sorting, setSorting] = useState({
        key: "",
        order: ""
    });
    const { subsId, dayId, id } = useParams();
    const navigate = useNavigate();

   const {
    data: response,
    isLoading,
    mutate: getVervangerData,
} = useVervangerData(
    pageSize,
    page,
    search,
    sorting.key,
    sorting.order,
    id
);

    const data = response?.data || [];
    const count=response?.totalCount

    const totalPageCount = response?.pageCount || 0;
    
    useEffect(() => {
        if (
            response?.status === false &&
            response?.error === "invalid_link"
        ) {
            navigate("/no-page-found");
        }
    }, [response, navigate]);

    const handleSorting = (newKey) => {
        setSorting((prev) => {
            if (prev.key === newKey) {
                if (prev.order === "asc") {
                    return { key: newKey, order: "desc" }
                } else if (prev.order === "desc") {
                    return { key: "", order: "" }
                } else {
                    return { key: newKey, order: "asc" }
                }
            } else {
                return { key: newKey, order: "asc" }
            }
        })
    };

    const searchHandler = (val) => {
        const delay = 1200;
        const timeoutId = setTimeout(() => {
            setPage(1);
            setSearchValue(val);
        }, delay);

        return () => {
            clearTimeout(timeoutId);
        };
    }

    return (
        <Fragment>
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="10" lg="10">
                            <PageHeading />
                        </Col>
                    </Row>
                    <Row style={{ cursor: 'pointer' }}>
                        <Col md="12" lg="12" className="pb-5">
                            <Records data={data} showLoader={isLoading} iCommunityId={id} subsId={subsId} dayId={dayId} getVervangerData={getVervangerData}
                                pageNumber={page} setPageNumber={setPage}
                                totalPageCount={totalPageCount} pageSizeCount={pageSize}
                                setPageSizeCount={setPageSize}
                                searchHandler={searchHandler}
                                sortParams={sorting}
                                handleSorting={handleSorting} />
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>

        </Fragment>

    )
};

export default Default;